import { render, staticRenderFns } from "./Dokument.vue?vue&type=template&id=58c64b92"
import script from "./Dokument.vue?vue&type=script&lang=js"
export * from "./Dokument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports